import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createSetMoscowPrioCommand } from '../../../api/commands/factory/createPrioCommands';
import { MoscowPrioValue } from '../../../api/queries';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetMoscowPrio extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SetMoscowPrio';

    public constructor(public cardId: string, public priority: MoscowPrioValue) {
        super(SetMoscowPrio.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetMoscowPrio): Promise<boolean> => {
    useSendCommandAsync(action, {
        createCommand: async () => await createSetMoscowPrioCommand(action),
    });

    return true;
};

const reducer = (state: StorymapState, action: SetMoscowPrio): void => {
    const card = state.subtasks.find((x) => x.id === action.cardId);

    card.moscowPrioValue = action.priority;
    card.lastUpdatedAt = new Date();
};

//@ts-ignore
registerMiddleware(SetMoscowPrio.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetMoscowPrio.ACTION_TYPE, reducer);
